import axios from 'axios'
import {Message, MessageBox} from 'element-ui'
import {Notify} from 'vant'
import store from '../store'
import qs from 'qs'
import {uid} from 'uid'
import {netLogEvent} from './util'
import {isWxWork} from './util'
import createMockAdapter from '@/api/mocks/index';
// var loginUrl = process.env.VUE_APP_URL_LOGIN
// var baseUrl = process.env.VUE_APP_BASE_API
var loginUrl = `${location.origin}/b/login`
var baseUrl = `${location.origin}/b/api/`
var env = process.env.NODE_ENV
let service = axios;


service.defaults.headers.post['Content-Type'] = 'application/json';
if (env !== 'mock') {
  // console.log(baseUrl)
  // 创建axios实例
  service = axios.create({
    baseURL: '/b/api/', // api的base_url
    timeout: 1000 * 60 * 10,                 // 请求超时时间,默认10分钟，有些接口查询就是慢，但是可以让用户等待，那就等等
  })
  service.defaults.withCredentials = true
}
/** 判断是否企业微信客户端 */
const isWxWorkClient = isWxWork()
const isMobile = /Mobile/.test(navigator.userAgent)
// request拦截器
service.interceptors.request.use(config => {
  // console.log('config', config)
  let requestUUIDV4 = uid()
  
  // errorCode作为追踪错误日志使用
  config.headers.errorCode = requestUUIDV4;

  if (config.data && typeof (config.data) !='string' && config.headers['Content-Type']!=='application/json;charset=UTF-8' && config.headers['Content-Type'] !== 'multipart/form-data') {
    // console.log('Content-Type', config.headers['Content-Type'])
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    config.data = qs.stringify(config.data)
  }

  return config
}, error => {
  // Do something with request error
  // console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  async response => {
    // console.log('response', response, document.cookie)
    // Promise.reject(response)
    let ajaxResult = response.data

    // 如果响应类型是blob
    const isResponseBlob = response&&response.config&&response.config.responseType==='blob'
    if(isResponseBlob){
      const contentDisposition = response&&response.headers&&response.headers['content-disposition']
      if(!(contentDisposition&&contentDisposition.indexOf('attachment;filename=')>-1)){
        try {
          ajaxResult = JSON.parse(await response.data.text())
        } catch (error) {
          
        }
      }
    }

    // console.log('ajaxResult', ajaxResult)
    if (ajaxResult.error && ajaxResult.error.code !=600) {
      
      let error = ajaxResult.error;
      if (error.code === 401) {
        store.dispatch('FedLogout').then(() => {
          location.href = loginUrl;
        })
      } else {
        const {config={}} = response
        const {headers={}} = config
        const {errorCode} = headers

        if (config.skipErrorHandler) {
          return Promise.reject(error)
        }

        if (isWxWorkClient || isMobile) { // 企业微信用户打开，显示移动端的提示
          Notify({ type: 'danger', message: ajaxResult.error.message });

        } else {
          Message.closeAll()
          Message({
            dangerouslyUseHTMLString: true,
            showClose: true,
            // message: `<div style="text-align: center; line-height: 2; padding: 0 5px;">啊哦 •︠ˍ•︡ 系统遇到点小问题~技术小哥哥正赶来处理...<br/>errorCode:${errorCode}</div>`,
            message: `<div style="text-align: center; line-height: 2; padding: 0 5px;">${ajaxResult.error.message}`,
            type: 'error',
            duration: 5 * 1000
          })

        }

        
        try {
          netLogEvent('clicking', 'apiErrorLog', `[${env}][E教学]响应错误日志上报`, {localCreateTime: new Date().toLocaleString(), errorCode, cookie: document.cookie, ...response})
        } catch (error) {
        }
        return Promise.reject(new Error(error.message))
      }
    } else {
      if(ajaxResult.error && ajaxResult.error.code ==600){
        return ajaxResult
      }

      if(isResponseBlob){
        const contentDisposition = response&&response.headers&&response.headers['content-disposition']
        if(!(contentDisposition&&contentDisposition.indexOf('attachment;filename=')>-1)){
          try {
            ajaxResult = JSON.parse(await response.data.text())
            return ajaxResult.result
          } catch (error) {

          }
        }else{
          // 如果后端返回xlsx文件流，下载
          const blob = new Blob([ajaxResult])
          const linkNode = document.createElement('a');
          linkNode.style.display = 'none';
          linkNode.href = URL.createObjectURL(blob);
          linkNode.download = window.decodeURIComponent(contentDisposition.split('filename=')[1])
          document.body.appendChild(linkNode);
          linkNode.click();
          URL.revokeObjectURL(linkNode.href);
          document.body.removeChild(linkNode);
          return response
        }
      }else{
        return ajaxResult.hasOwnProperty('result')? ajaxResult.result : ajaxResult
      }
    }

  },
  error => {
    if (error.config && error.config.skipErrorHandler) {
      return Promise.reject(error)
    }
    let errMessage = error.message || '服务器异常'
    if (isWxWorkClient) { // 企业微信用户打开，显示移动端的提示
      Notify({ type: 'danger', message: errMessage });

    } else {
      Message.closeAll()
      Message({
        message: errMessage,
        type: 'error',
        duration: 5 * 1000
      })

    }
    
    netLogEvent('clicking', 'apiErrorLog', `[${env}][E教学]响应错误日志上报`, {localCreateTime: new Date().toLocaleString(), errorCode: '服务器接口超时300000ms或网络错误'})
    return Promise.reject(error)
  }
)
console.log('process.env', process.env.NODE_ENV)
if (process.env.NODE_ENV == "development") {
  createMockAdapter(service)
}
export default service
